import { EmailHistoryRecord } from '../typings'

export const getEmailHistoryStatus = (record: EmailHistoryRecord) => {
  if (!!record.date_lastClicked) return 'Clicked'
  else if (!!record.date_lastOpened) return 'Opened'
  else if (!!record.date_delivered) return 'Delivered'
  else if (!!record.date_failed) return 'Failed'
  else if (!!record.date_sent) return 'Sent'
  else if (!!record.date_cancelled) return 'Cancelled'
  else return 'Queued'
}
